import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d65f17a749570014e75cb4/eventgame/node_modules/next/dist/client/components/client-page.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d65f17a749570014e75cb4/eventgame/node_modules/next/dist/client/components/client-segment.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d65f17a749570014e75cb4/eventgame/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d65f17a749570014e75cb4/eventgame/node_modules/next/dist/client/components/http-access-fallback/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d65f17a749570014e75cb4/eventgame/node_modules/next/dist/client/components/layout-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d65f17a749570014e75cb4/eventgame/node_modules/next/dist/client/components/render-from-template-context.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d65f17a749570014e75cb4/eventgame/node_modules/next/dist/lib/metadata/metadata-boundary.js");
